export type ApprovalDisplayStatus = "APPROVED" | "PENDING" | "REJECTED" | "REVIEWING" | "WAITING";

function ApproverStatusPill({ status, t, label }: { status: ApprovalDisplayStatus; t: (s: string) => string; label?: string }) {
  const styles = {
    APPROVED: "bg-green/10 text-green",
    PENDING: "bg-blue/10 text-blue",
    REJECTED: "bg-red/10 text-red",
    REVIEWING: "bg-blue/10 text-blue",
    WAITING: "bg-gray-100 text-gray-500",
  };
  const labels = {
    APPROVED: t("Approved"),
    PENDING: t("Pending"),
    REJECTED: t("Rejected"),
    REVIEWING: t("Reviewing"),
    WAITING: t("Waiting"),
  };
  return (
    <div className={`text-xs font-gilroy font-semibold px-2 py-0.5 rounded-full shrink-0 ${styles[status]}`}>
      {label ?? labels[status]}
    </div>
  );
}

export default ApproverStatusPill;
